import moment from "moment";

export const StockDetailsHeaderConfig = [
  {
    label: "Status",
    id: "status",
  },
  { label: "List Number", id: "listNumber" },
  {
    label: "Plant",
    id: "plant",
  },
  {
    label: "Serial Number",
    id: "serialNumber",
  },
  { label: "Model", id: "model" },
  {
    label: "Created At",
    id: "createdAt",
    render: (data) => {
      return (
        <span>
          {data?.createdAt && moment(data.createdAt).format("DD/MM/YYYY")}
        </span>
      );
    },
  },
];
